import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que dejar de comer todo lo que me gusta?',
    a: 'No. El protocolo se enfoca principalmente en ajustar ciertos ingredientes y hábitos durante la ventana nocturna (las horas antes de dormir). El resto del día mantienes mucha más flexibilidad.'
  }, {
    q: '¿Es una guía médica?',
    a: 'No. Es una guía educativa basada en la modificación de hábitos, rutinas de hidratación y técnicas de vaciado. No sustituye el consejo, diagnóstico o tratamiento de tu médico.'
  }, {
    q: '¿Cuándo suelen notarse cambios?',
    a: 'Muchos hombres notan una diferencia en la tranquilidad de sus noches durante la primera semana de aplicar el protocolo de manera consistente, especialmente al identificar sus irritantes personales.'
  }, {
    q: '¿Necesito equipo especial?',
    a: 'Absolutamente nada. Todo lo que necesitas para aplicar este protocolo ya lo tienes en tu casa.'
  }, {
    q: '¿Qué formato recibo?',
    a: 'Recibirás un archivo digital en formato PDF de alta calidad. Puedes leerlo en tu teléfono, tablet, computadora, o imprimirlo si prefieres leer en papel.'
  }, {
    q: '¿Cómo accedo a la guía?',
    a: 'Inmediatamente después de completar tu compra segura, serás redirigido a la página de descarga y también recibirás un correo electrónico con el enlace para acceder a tu guía y a los bonos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-navy-950 py-20 md:py-28 relative text-cream-50 border-t border-navy-800" data-id="element-47">
      <div className="container mx-auto px-4" data-id="element-48">
        <div className="max-w-[800px] mx-auto" data-id="element-49">
          <FadeIn data-id="element-50">
            <div className="text-center mb-16" data-id="element-51">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-52">
                Preguntas Frecuentes
              </h2>
            </div>
          </FadeIn>

          <div className="space-y-4" data-id="element-53">
            {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-54">
                <div className="bg-navy-900 rounded-2xl border border-navy-800 overflow-hidden transition-colors hover:border-navy-700" data-id="element-55">
                  <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-6 text-left flex items-start justify-between focus:outline-none" data-id="element-56">
                    <span className="text-lg font-bold text-white pr-8 leading-snug" data-id="element-57">
                      {faq.q}
                    </span>
                    <ChevronDown className={`text-gold-500 shrink-0 mt-1 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-58" />
                  </button>
                  <AnimatePresence data-id="element-59">
                    {openIndex === index && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-60">
                        <div className="px-6 pb-6 text-cream-100/70 leading-relaxed border-t border-navy-800/50 pt-4 mt-2" data-id="element-61">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}